/**
 * Locale-relative path segments for SSG output: dist/{locale}/{segment}.html
 * (home → index.html).
 *
 * Single source of truth for:
 * - `scripts/build-ssg.mjs` (Node cannot import `index.js` — it pulls in `.vue` files)
 * - `getSSGPaths()` in `index.js`
 * - `meta.ssg` on each matching route (via `SSG_ROUTE_NAMES`)
 *
 * When adding a new pre-rendered public page, append here and add the route + nginx `try_files`.
 */

export const SSG_BUILD_ROUTES = [
  { path: '', name: 'home' },
  { path: '/property', name: 'property' },
  { path: '/location', name: 'location' },
  { path: '/availability', name: 'availability' },
  { path: '/feedback', name: 'feedback' },
  { path: '/privacy-policy', name: 'privacy-policy' },
  { path: '/terms-of-service', name: 'terms-of-service' }
];

export const SSG_ROUTE_NAMES = new Set(SSG_BUILD_ROUTES.map((r) => r.name));
